<template >
  <div>
    <v-dialog
      v-if="$store.state.logged"
      v-model="video"
      width="710"
      persistent
    > 
      <v-card flat>
        <section>
          <iframe
            width="100%"
            :height="$vuetify.breakpoint.xs ? '200' : '400' "
            src="https://www.youtube.com/embed/elpmzvCgSPw"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </section>
        <div class="d-flex justify-end align-end">
          <v-btn @click="video = false" class="ma-2" color="#4B2A66" dark
            >Vamos lá</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <div v-if="!$store.state.logged">
    
      <div class="text-h3 text-center font-weight-medium my-5">
        Cadastro pessoal
      </div>
      <v-container>
        <v-card class="my-5 mx-2 elevation-10">
          <v-col cols="12">
            <v-card-text>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="user.name"
                      :rules="[$rules.required]"
                      label="Nome Completo *"
                      required
                      :disabled="loading"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="user.telephone"
                      :rules="[$rules.required, $rules.phone]"
                      label="Telefone *"
                      :disabled="loading"
                      placeholder="(00) 12345-1234"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="user.genre"
                      :rules="[$rules.required]"
                      label="Gênero *"
                      :disabled="loading"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="business.birth_date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="birthDateFormatted"
                          label="Data de Nascimento"
                          readonly
                          :disabled="loading"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="user.birth_date"
                        no-title
                        scrollable
                        locale="pt-br"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false">
                          Cancelar
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(business.birth_date)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field
                      v-model="user.email"
                      :rules="[$rules.required, $rules.email]"
                      label="E-mail *"
                      required
                      :disabled="loading"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <v-text-field
                      v-model="user.password"
                      :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      :rules="[$rules.required, $rules.passwordMin]"
                      :type="showPassword ? 'text' : 'password'"
                      name="input-10-1"
                      label="Senha *"
                      hint="No mínimo 8 caracteres"
                      @click:append="showPassword = !showPassword"
                      :disabled="loading"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <v-text-field
                      :rules="[
                        $rules.required,
                        $rules.passwordMin,
                        $rules.equalPassword(() => user.password),
                      ]"
                      :append-icon="showPassword1 ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="showPassword1 ? 'text' : 'password'"
                      name="input-10-1"
                      label="Confirmação de Senha *"
                      hint="No mínimo 8 caracteres"
                      @click:append="showPassword1 = !showPassword1"
                      :disabled="loading"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <v-select
                      v-model="user.state"
                      item-text="name"
                      item-value="id"
                      :items="states"
                      :rules="[$rules.required]"
                      :loading="loadingState"
                      :disabled="disabledState"
                      label="Estado *"
                    />
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                    <v-select
                      v-model="user.city_id"
                      item-text="name"
                      item-value="id"
                      :items="cities"
                      :rules="[$rules.required]"
                      :disabled="disabledCity"
                      label="Cidade *"
                      placeholder="Selecione primeiro o estado"
                    />
                  </v-col>
                </v-row>

                <v-checkbox
                  v-model="checkbox"
                  :rules="[(v) => !!v || 'Você deve aceitar para continuar']"
                  label="Você concorda com os nossos termos de serviço?"
                  required
                  :disabled="loading"
                />

                <v-alert
                  v-model="emailalert"
                  type="warning"
                  transition="scale-transition"
                  >Esse E-mail já está em uso</v-alert
                >
                <v-alert
                  v-model="errorName"
                  type="error"
                  transition="scale-transition"
                >
                  Um erro inesperado aconteceu, contate-nos ou tente novamente
                  mais tarde
                </v-alert>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="#4B2A66"
                outlined
                exact
                :to="{ name: 'home' }"
                :disabled="loading"
                dark
              >
                Cancelar
              </v-btn>
              <v-btn
                color="#4B2A66"
                class="mr-1"
                @click="register"
                :loading="loading"
                dark
              >
                Cadastrar
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-card>
        <v-snackbar v-model="snackbar" multi-line color="blue" rounded="pill"
          ><template v-slot:action="{ attrs }">
            <v-btn color="pink" icon v-bind="attrs" @click="snackbar = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          Cadastro realizado com sucesso!
        </v-snackbar>
      </v-container>
    </div>
    <v-sheet
      height="100%"
      v-if="webShareApiSupported && $store.state.logged" 
    > 
    
      <v-container>
        <v-stepper v-model="e1" ref="stepper">
          <v-stepper-items>
            <v-stepper-content step="1">
              <div class="text-h5">Negócio ou Marca</div>
              <v-row align="center">
                <!--REVISAR RULES DAS TEXT-FIELDS-->
                <v-col>
                  <v-form
                    ref="form"
                    v-model="valid"
                    :lazy-validation="lazy"
                    class="ma-3"
                  >
                    <div align="center">
                      <v-col cols="12" sm="6" md="10">
                        <v-text-field
                          v-model="business.shop_name"
                          :lazy-validation="lazy"
                          label="Nome da sua página *"
                          :rules="[$rules.required]"
                          required
                        />
                      </v-col>
                      <v-alert
                        v-model="errorName"
                        type="error"
                        transition="scale-transition"
                      >
                        Infelizmente já existe uma negócio com esse nome!
                      </v-alert>
                      <v-col cols="12" sm="6" md="10">
                        <v-select
                          v-model="business.category_id"
                          :loading="loadingCategory"
                          :disabled="disabledCategory"
                          item-text="name"
                          item-value="id"
                          :items="categories"
                          :rules="[$rules.required]"
                          label="Categoria *"
                          required
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="10">
                        <v-text-field
                          v-model="business.email"
                          :rules="[$rules.email]"
                          label="E-mail"
                          required
                        />
                      </v-col>
                    </div>
                    <div align="right">
                    <v-btn
                      class="mr-4 my-4"
                      color="#4B2A66"
                      outlined
                      @click="reset"
                      :to="{ name: 'home' }"
                      dark
                      exact
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      class="mr-3"
                      color="#4B2A66"
                      @click="validShop"
                      dark
                    >
                      Continuar
                    </v-btn>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="2">
              <div class="text-h5">Localização</div>
              <div class="text-subtitle-2">
                Informe sua localização e contato para que seus clientes possam
                lhe encontrar
              </div>
              <div class="my-2" v-show="false">
                <v-btn small class="pink--text text--darken-4" outlined>
                  Informe sua localização no mapa
                </v-btn>
              </div>

              <div v-show="false" class="text-subtitle-2 ml-1">
                Ou preencha o formulário
              </div>
              <v-form
                ref="formlocation"
                v-model="location"
                :lazy-validation="lazyLocation"
                class="ma-3"
              >
                <v-row class="mb-11">
                  <v-col cols="6" sm="6" md="6">
                    <v-select
                      v-model="state"
                      :loading="loadingState"
                      :disabled="disabledState"
                      item-text="name"
                      item-value="id"
                      :items="states"
                      :rules="[(v) => !!v || 'Informe um Estado']"
                      label="Estado *"
                      required
                    />
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-select
                      v-model="business.city_id"
                      :disabled="disabledCity"
                      item-text="name"
                      item-value="id"
                      :items="cities"
                      :rules="[(v) => !!v || 'Informe uma cidade']"
                      label="Cidade *"
                      required
                    />
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="business.neighborhood"
                      label="Bairro"
                      required
                    />
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="business.street"
                      label="Rua"
                      required
                    />
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="business.number"
                      label="Número"
                      required
                    />
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="business.complement"
                      label="Complemento"
                    />
                  </v-col>
                  <v-col v-show="false">
                    <v-checkbox
                      v-model="checkbox"
                      label="Não quero que apareça minha localização, apenas informe que meu estabelecimento se encontra na região"
                    />
                  </v-col>
                </v-row>
              </v-form>
              <div align="right">
              <v-btn @click="e1 = 1" class="mr-4 my-4" color="#4B2A66" outlined dark>
                Voltar
              </v-btn>
              <v-btn
                @click="validLocation"
                class="mr-4 my-4"
                color="#4B2A66"
                dark
                >Continuar</v-btn
              >
              </div>
            </v-stepper-content>
            <v-stepper-content step="3">
              <div class="text-h5">Perfil</div>
              <v-card class="mb-12 elevation-0 pa-2">
                <v-row>
                  <v-col cols="12" md="3">
                    <div style="width: 100%" class="d-flex justify-center mb-8">
                      <v-card
                        v-show="visibleLogo"
                        width="300"
                        height="250"
                        class="elevation-10 align-center d-flex pa-4"

                      >
                        <v-img src="@/assets/logo.png" />
                      </v-card>
                      <v-card v-show="visibleImage" class="elevation-5">
                        <v-img :src="business.photograph" />
                      </v-card>
                    </div>
                    <v-btn
                      @click="$refs.fileInput.click()"
                      small
                      width="100%"
                      class="elevation-5 d-flex"
                      color="#4B2A66"
                      dark
                      >Selecionar Imagem</v-btn
                    >
                    <v-alert
                      v-model="alertImage"
                      dense
                      outlined
                      type="error"
                      transition="scale-transition"
                    >
                      Selecione uma imagem!
                    </v-alert>
                    <input
                      ref="fileInput"
                      type="file"
                      accept="image/png, image/jpeg, image/bmp"
                      @input="pickFile"
                      class="d-none"
                    />
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-card class="elevation-0">
                      <div class="text-h6">Contato</div>
                      <div class="text-subtitle-2 font-weight-regular grey--text text--darken-1">As informações registradas abaixo auxiliarão no contato dos seus Clientes com seu Negócio, por isso preencha com o máximo de detalhes possíveis.</div>
                      <v-card class="elevation-0">
                        <v-row class="d-flex justify-center">
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              v-model="business.telephone"
                              label="Telefone"
                              :rules="[$rules.phone]"
                              placeholder="(00) 12345-1234"
                              v-mask="['(##) ####-####', '(##) #####-####']"
                            />
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              v-model="business.whatsapp_link"
                              label="Telefone para Whatsapp"
                              :rules="[$rules.phone]"
                              placeholder="(00) 12345-1234"
                              v-mask="['(##) ####-####', '(##) #####-####']"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="d-flex justify-center">
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              v-model="business.instagram_link"
                              label="Instagram"
                              placeholder="instagram.com/olhadela"
                            />
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              v-model="business.facebook_link"
                              label="Facebook"
                              placeholder="facebook.com/olhadela"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="d-flex justify-center">
                          <v-col cols="6" sm="6" md="6">
                            <v-text-field
                              v-model="business.cnpj"
                              label="Cnpj"
                              :rules="[$rules.cnpj]"
                              placeholder="00.000.000/0000-00"
                              v-mask="'##.###.###/####-##'"
                            />
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-textarea
                              v-model="business.description"
                              label="Descrição"
                              placeholder="Como você descreveria sua empresa?"
                              outlined
                              height="150px"
                            />
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-card>

                    <v-alert
                      v-model="errorLoading"
                      type="error"
                      transition="scale-transition"
                    >
                      Um erro inesperado aconteceu, contate-nos ou tente
                      novamente mais tarde!
                    </v-alert>
                  </v-col>
                </v-row>
              </v-card>
              <div align="right">              
              <v-btn @click="e1 = 2" class="mr-4 my-4" color="#4B2A66" outlined
                >Voltar</v-btn
              >
              <v-btn
                class="mr-4 my-4"
                color="#4B2A66"
                @click="create"
                dark
              >
                Cadastrar
              </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-sheet>
    <v-sheet v-else>
      <div v-if="$store.state.logged">
        <div class="text-h3 text-center font-weight-medium my-5">
          Inicie o cadastramento do seu negócio
        </div>

        <v-container>
          <v-form
            ref="formBusiness"
            v-model="valid"
            :lazy-validation="lazy"
            class="ma-3 elevation-10"
          >
            <v-sheet class="elevation-1" outlined>
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="mb-10 text-h5 font-weight-bold">
                      Negócio ou Marca
                    </div>
                    <div class="font-weight-bold">
                      Qual o nome do seu negócio? *
                    </div>
                    <v-text-field
                      dense
                      placeholder="Nome da página"
                      v-model="business.shop_name"
                      :lazy-validation="lazy"
                      :rules="[$rules.required]"
                      required
                    />
                    <v-alert
                      v-model="errorName"
                      type="error"
                      transition="scale-transition"
                    >
                      Infelizmente já existe uma negócio com esse nome!
                    </v-alert>
                    <div class="font-weight-bold mt-10">
                      Escolha uma categoria para o seu negócio *
                    </div>
                    <v-select
                      class="mb-10"
                      v-model="business.category_id"
                      :loading="loadingCategory"
                      :disabled="disabledCategory"
                      item-text="name"
                      item-value="id"
                      :items="categories"
                      :rules="[$rules.required]"
                      requiredclass=""
                      dense
                      placeholder="Categoria"
                    />
                    <div class="font-weight-bold">
                      Informe um Email para o seu negócio
                    </div>
                    <v-text-field
                      v-model="business.email"
                      :rules="[$rules.email]"
                      class="mb-10"
                      dense
                      placeholder="E-mail"
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex align-center">
                    <v-img src="@/assets/create.png" />
                  </v-col>
                </v-row>
                <v-divider />
                <v-row>
                  <v-col cols="6" v-if="$vuetify.breakpoint.mdAndUp">
                    <v-img src="@/assets/location.png" height="500px" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="mb-10 text-h5 font-weight-bold">
                      Localização
                    </div>
                    <v-row align="center">
                      <v-col cols="12" md="6">
                        <div class="font-weight-bold">Estado *</div>
                        <v-select
                          :loading="loadingState"
                          :disabled="disabledState"
                          v-model="state"
                          item-text="name"
                          item-value="id"
                          :items="states"
                          :rules="[(v) => !!v || 'Informe um estado.']"
                          dense
                          placeholder="Ex: Santa Catarina"
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="font-weight-bold">Cidade *</div>
                        <v-select
                          v-model="business.city_id"
                          :disabled="disabledCity"
                          item-text="name"
                          item-value="id"
                          :items="cities"
                          :rules="[(v) => !!v || 'Informe uma cidade.']"
                          dense
                          placeholder="Ex: São Miguel do Oeste"
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="font-weight-bold">Bairro</div>
                        <v-text-field
                          v-model="business.neighborhood"
                          placeholder="Ex: Centro"
                          dense
                          required
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="font-weight-bold">Rua</div>
                        <v-text-field
                          v-model="business.street"
                          dense
                          placeholder="Ex: 25 de Março"
                          required
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="font-weight-bold">Número</div>
                        <v-text-field
                          v-model="business.number"
                          dense
                          placeholder="XXXX"
                          required
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="font-weight-bold">Complemento</div>
                        <v-text-field v-model="business.complement" dense />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-divider />
                <v-row align="center">
                  <v-col cols="12" md="6">
                    <div class="text-h5 mb-16 font-weight-bold text-center">
                      Selecione uma imagem da sua marca
                    </div>
                    <div style="width: 100%" class="d-flex justify-center mb-8">
                      <v-card
                        v-show="visibleLogo"
                        width="300"
                        height="300"
                        class="elevation-5"
                      >
                        <v-img src="@/assets/olhadela_logo.png" />
                      </v-card>
                      <v-card v-show="visibleImage" class="elevation-5">
                        <v-img
                          :src="business.photograph"
                          width="300"
                          height="300"
                        />
                      </v-card>
                    </div>
                    <div
                      style="width: 100%"
                      class="d-flex justify-center"
                      plain
                    >
                      <v-btn dark @click="$refs.fileInput.click()">
                        Selecionar Imagem
                      </v-btn>
                    </div>
                    <v-alert
                      v-model="alertImage"
                      dense
                      outlined
                      type="error"
                      transition="scale-transition"
                    >
                      Selecione uma imagem!
                    </v-alert>

                    <input
                      ref="fileInput"
                      type="file"
                      accept="image/png, image/jpeg, image/bmp"
                      @input="pickFile"
                      class="d-none"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="text-h5 font-weight-bold">Contato</div>
                    <v-row justify="center">
                      <v-col cols="6">
                        <div class="font-weight-bold">
                          Telefone para ligações
                        </div>
                        <v-text-field
                          v-model="business.telephone"
                          dense
                          :rules="[$rules.phone]"
                          placeholder="(00) 12345-1234"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                        />
                      </v-col>
                      <v-col cols="6">
                        <div class="font-weight-bold">
                          Telefone para Whatsapp
                        </div>
                        <v-text-field
                          v-model="business.whatsapp_link"
                          dense
                          :rules="[$rules.phone]"
                          placeholder="(00) 12345-1234"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                        />
                      </v-col>
                      <v-col cols="6">
                        <div class="font-weight-bold">Instagram</div>
                        <v-text-field
                          v-model="business.instagram_link"
                          dense
                          placeholder="instagram.com/olhadela"
                        />
                      </v-col>
                      <v-col cols="6">
                        <div class="font-weight-bold">Facebook</div>
                        <v-text-field
                          v-model="business.facebook_link"
                          dense
                          placeholder="facebook.com/olhadela"
                        />
                      </v-col>
                      <v-col cols="12" md="6">
                        <div class="font-weight-bold">CNPJ</div>
                        <v-text-field
                          v-model="business.cnpj"
                          dense
                          :rules="[$rules.cnpj]"
                          placeholder="00.000.000/0000-00"
                          v-mask="'##.###.###/####-##'"
                        />
                      </v-col>
                      <v-col cols="12">
                        <div class="font-weight-bold">Descrição</div>
                        <v-textarea
                          solo
                          placeholder="Como você descreveria sua empresa?"
                          v-model="business.description"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-alert
                  v-model="errorName"
                  type="error"
                  style="width: 100%"
                  transition="scale-transition"
                >
                  Um erro inesperado aconteceu, contate-nos ou tente novamente
                  mais tarde!
                </v-alert>

                <div class="d-flex justify-end py-2">
                  <v-btn
                    color="red"
                    :to="{ name: 'home' }"
                    :disabled="loading"
                    dark
                    >Cancelar</v-btn
                  >
                  <v-btn class="ml-3" color="success" @click="create" dark>
                    Enviar
                  </v-btn>
                </div>
              </v-container>
            </v-sheet>
          </v-form>
        </v-container>
      </div>
    </v-sheet>
  </div>
</template>

<script>
export default {
  data: () => ({
    user: {
      password: "",
      name: "",
      email: "",
      telephone: "",
      city_id: undefined,
      birth_date: new Date().toISOString().substr(0, 10),
      genre: "",
    },
    business: {
      shop_name: "",
      url: "",
      cnpj: "",
      facebook_link: "",
      instagram_link: "",
      email: "",
      telephone: "",
      whatsapp_link: "",
      photograph: "",
      description: "",
      neighborhood: "",
      street: "",
      number: "",
      complement: "",
      category_id: undefined,
      city_id: undefined,
    },

    disabledCity: true,
    loadingState: true,
    disabledState: true,
    loadingCategory: true,
    disabledCategory: true,
    visibleImage: false,
    visibleLogo: true,
    errorName: false,
    errorLoading: false,
    e1: 1,
    valid: true,
    location: true,
    select: null,
    categories: [],
    shop: [],
    state: undefined,
    states: [],
    cities: [],
    checkbox: false,
    lazy: false,
    lazyLocation: false,
    loading: false,
    previewImage: null,
    menu: false,
    login: { email: "", password: "" },
    emailalert: false,
    video: true,
    alertImage: false,
    snackbar: false,
    files: [],
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    address: "",
    addressRules: [(v) => !!v || "Informe um endereço"],
    showPassword: false,
    showPassword1: false,
  }),

  methods: {
    register() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.emailalert = false;
        this.errorName = false;
        this.login.email = this.user.email;
        this.login.password = this.user.password;
        this.$axios
          .post("/user", this.user)
          .then(() => {
            this.$axios.put("/login", this.login).finally(() => {
              document.location.reload();
            });
            this.$emit("logged");
            this.snackbar = true;
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 400) {
                this.emailalert = true;
              } else {
                this.errorName = true;
              }
            } else {
              this.errorName = true;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    validShop() {
      if (this.$refs.form.validate() && this.errorName == false) {
        this.e1 = 2;
      }
    },
    validLocation() {
      if (this.$refs.formlocation.validate()) {
        this.e1 = 3;
      }
    },
    create() {
      if (this.business.photograph != "") {
        this.$axios
          .post("/shop", this.business)
          .then((response) => {
            (this.shop = response.data),
              this.$router.replace({
                path: "meu-negocio/" + this.shop,
              });
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 400) {
                this.errorName = true;
              } else {
                this.errorLoading = true;
              }
            }
          });
      } else {
        this.alertImage = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.business.photograph = e.target.result;
          this.visibleLogo = false;
          this.visibleImage = true;
        };
        reader.readAsDataURL(file[0]);
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },

  computed: {
    birthDateFormatted() {
      return this.formatDate(this.user.birth_date);
    },
    webShareApiSupported() {
      return navigator.share;
    },
  },

  mounted() {
    this.$axios.get("/categories").then((response) => {
      this.categories = response.data;
      this.loadingCategory = false;
      this.disabledCategory = false;
    });

    this.$axios.get("/states").then((response) => {
      this.states = response.data;
      this.loadingState = false;
      this.disabledState = false;
    });
    document.title = `Olhadela - Registro de Negócio`;
  },
  watch: {
    state(state_id) {
      if (!state_id) {
        this.cities = [];
      } else {
        this.$axios.get("/cities/" + state_id).then((response) => {
          this.cities = response.data;
          this.disabledCity = false;
        });
      }
    },
    "user.state"(state_id) {
      if (!state_id) {
        this.cities = [];
      } else {
        this.$axios.get("/cities/" + state_id).then((response) => {
          this.cities = response.data;
          this.disabledCity = false;
        });
      }
    },
    "business.photograph"() {
      this.alertImage = false;
    },
    "business.shop_name"() {
      this.errorName = false;
      this.$axios
        .get("/shop_name/" + this.business.shop_name)

        .then(() => {})
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 400) {
              this.errorName = true;
            }
          }
        });
    },
  },
};
</script>
